exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Cu2yB8ZOVvr4xR{background-clip:content-box;background-origin:content-box;color:#fff;padding:6px;position:absolute;top:0;left:0}.body-light-board-background .Cu2yB8ZOVvr4xR{color:#42526e}", ""]);

// exports
exports.locals = {
	"boardViewsButtonIcon": "Cu2yB8ZOVvr4xR"
};